/* ------------------------------------------------------------------------------
 *
 *  # SubCategoria Management Components
 *
 *  Grid de Subcategorías con acciones
 *
 * ---------------------------------------------------------------------------- */

import { destroyDataTable, initGenericDataTable } from '../integrations/datatables.js';

// Callback reference
let subCategoriaCallbacks = null;

export function initSubCategoriaTable(subCategorias) {
    destroyDataTable('subCategoriaTable');

    const tableData = subCategorias.map(sc => [
        generateActions(sc),
        sc.nombre,
        sc.categoriaNombre,
        sc.orden
    ]);

    const options = {
        data: tableData,
        columns: [
            { title: 'Acciones', orderable: false, className: 'text-center', width: '120px' },
            { title: 'Nombre' },
            { title: 'Categoría' },
            { title: 'Orden', className: 'text-center' }
        ],
        order: [[1, 'asc']]
    };

    initGenericDataTable('subCategoriaTable', options);
}

function generateActions(subCategoria) {
    return `
        <div class="d-inline-flex">
            <a href="javascript:void(0)" class="text-body me-2" onclick="window.sfBlazorSB.subCategorias.edit(${subCategoria.id})" title="Editar">
                <i class="ph-pencil"></i>
            </a>
            <a href="javascript:void(0)" class="text-body" onclick="window.sfBlazorSB.subCategorias.delete(${subCategoria.id})" title="Eliminar">
                <i class="ph-trash"></i>
            </a>
        </div>
    `;
}

// Refresh table
export function refreshSubCategoriaTable(subCategorias) {
    destroyDataTable('subCategoriaTable');
    initSubCategoriaTable(subCategorias);
}

// Set callbacks
export function setSubCategoriaCallbacks(dotNetRef) {
    subCategoriaCallbacks = dotNetRef;
}

// Edit action
export function editSubCategoria(id) {
    if (subCategoriaCallbacks) {
        subCategoriaCallbacks.invokeMethodAsync('EditSubCategoria', id);
    }
}

// Delete action
export async function deleteSubCategoria(id) {
    const result = await window.swalInit.fire({
        title: '¿Eliminar Subcategoría?',
        text: '¿Estás seguro de que deseas eliminar esta subcategoría?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dc3545'
    });

    if (result.isConfirmed && subCategoriaCallbacks) {
        await subCategoriaCallbacks.invokeMethodAsync('DeleteSubCategoria', id);
    }
}
